import { MODAL_TYPE } from "../constants";

const modalReducer = (state = {
   isOpen: false,
   data: {}
}, action) => {
   switch (action.type) {
      case MODAL_TYPE.OPEN:
         return {
            isOpen: true,
            data: action.payload
         }
      case MODAL_TYPE.CLOSE:
         return {
            isOpen: false,
            data: {}
         }
      default:
         return state;
   }
};

export default modalReducer;